<template>
  <div class="mainbox">
    <div class="mainbox-box" :class="{'sticky-top': isSticky}">
      <div class="mainbox-title">
        <span>Beratung gewünscht?</span>
      </div>
      <div class="row  mainbox-head">
        <div class="col  col-md-4 col-lg-4 col-xl-4 col-4" data-area-id="col-0">
          <div class="drop-portlet ">
            <img alt="" src="frontend/templates/images/wnm.jpg">
          </div>
        </div>
        <div class="col  col-md-8 col-lg-8 col-xl-8 col-8" data-area-id="col-1">
          <div style="position:relative;" class="opc-Container  mainbox-name-box">
            <div style="position: relative;">
              <div style="" class="mainbox-name">
                <p>WNM GMBH</p>
              </div>
              <div style="" class="mainbox-phone">
                <a href="tel:+4920229789220"><img alt="" class=" ls-is-cached lazyloaded" style="width: 18px; height: 18px; float: left;" src="/templates/NOVAChild/pictures/phone-icon.svg">+4920229789220</a>
              </div>
              <div style="" class="mainbox-mail">
                <a href="mailto:info@wnm.de"><img alt="" class=" ls-is-cached lazyloaded" style="width: 18px; height: 18px; float: left;" src="/templates/NOVAChild/pictures/mail-icon.svg">info@wnm.de</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupportBox",
  props: {
    isSticky: {
      type: Boolean,
      default: true,
    }
  },
}
</script>

<style scoped>
.mainbox a{
  text-decoration: none;
}

.mainbox-box {
  background: var(--color2) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 10px #00000029;
  padding: 20px;
  margin-top: 16px;
  z-index: 1;
}

.mainbox-title {
  font-size: 20px;
  color: var(--color1);
  font-weight: 500;
  margin-bottom: 8px;
}

.mainbox-head {
  margin-top: 20px;
}

.mainbox-box img {
  max-width: 80px;
  height: auto;
  border-radius: 50px;
}

.mainbox-name-box {}

.mainbox-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--color5);
}

.mainbox-phone, .mainbox-mail {
  margin: 5px;
}

.mainbox-phone a, .mainbox-mail a {
  margin: 5px;
}


</style>